import {DescriptorWikidataInfo} from "consts/khw-consts";
import {formatDate, translateKey} from "utils/fieldsFormatters";
import {lazy, use} from "react";
import {LanguageContext} from "context/LanguageContext";
import {renderWikidataUrl} from "utils/renderUrls";
import { Box } from "@mui/material";

const BoxAccordion = lazy(() => import("components/common/BoxAccordion"));
const InfoGridRow = lazy(() => import("components/descriptorInfo/InfoGridRow"));

interface DescriptorWikidataInfoCardProps {
    wikidataId: string
    data: DescriptorWikidataInfo
}

const DescriptorWikidataInfoCard = ({wikidataId, data}: DescriptorWikidataInfoCardProps) => {
    const {language} = use(LanguageContext);

    const renderRows = () => {
        return Object.entries(data).map(([key, value]) => {
            const label = translateKey(key, language, 'wikidata')
            const uniqueKey = `wikidata-${key}`
            if (key.toLowerCase().includes('date')) {
                const date = formatDate(value, language)
                if (date)
                    return <InfoGridRow key={uniqueKey} label={label} simpleValue={date} addBackground/>
                else return <></>

            } else if (key === 'signature') {
                return <InfoGridRow key={key} label={label} simpleValue={value} valueType={"image"} addBackground/>
            } else if (key === 'pronunciationAudio') {
                return <InfoGridRow key={key} label={label} simpleValue={value} valueType={"sound"} addBackground/>
            }
            return <InfoGridRow key={uniqueKey} label={label} simpleValue={value} addBackground/>
        })
    }


    return <BoxAccordion header={'wikidataInfo'} showBorderedCard
                         tooltipText={translateKey('wikidataTooltip', language)}>

        <Box className={'info-grid-box'}>
            <InfoGridRow key={'wikidataId'} label={translateKey('wikidataId', language)} simpleValue={wikidataId}
                         link={renderWikidataUrl(wikidataId)} addBackground/>
            {renderRows()}
        </Box>
    </BoxAccordion>


}

export default DescriptorWikidataInfoCard